module.exports = __webpack_public_path__ + "img/logo-horiz@3x.1aed24e3.png";